import React from "react";
import GalleryVideoDetailsPlayer from "../../pages/events/ViewPhoto/GalleryVideoDetailsPlayer";

const ThreeInOnePlayer = ({ activeItemIndex, dataSlider, threeInOneShareDetails }) => (
  <GalleryVideoDetailsPlayer
    activeItemIndex={activeItemIndex}
    dataSlider={dataSlider}
    directory="gif"
    fileKey="event_gif"
    initialDetails={threeInOneShareDetails}
    title="3 in 1 details"
  />
);

export default ThreeInOnePlayer;
